/*
 * Copyright (c) 2025 MTa Learning. All Rights Reserved.
 *
 * MTa Learning proprietary information: the enclosed materials contain proprietary information of MTa Learning and
 * shall not be disclosed in whole or in any part to any third party or used by any person for any purpose, without
 * written consent of MTa Learning. Duplication of any portion of these materials shall include this notice.
 */
'use client'

import { PaymentCurrencies } from '@mta/vela-api-types'
import { useTranslations } from 'next-intl'
import React from 'react'
import { useKitPrice } from '@/hooks/kits/useKitPrice'
import type { MtaKitStoryblok } from '@/lib/storyblok/types/generated-types'
import { formatPrice } from '@/utils/price-formatting'

/** A description of the available properties for this component. */
type KitPricingDisplayProps = {
  /** Pricing data picked from an MTa Kit. */
  pricingData: Pick<MtaKitStoryblok, 'default_pricing' | 'zone_pricing'>
}

/**
 * Client component responsible for calculating and displaying the kit price based on user's country selection.
 */
const KitPricingDisplay: React.FC<KitPricingDisplayProps> = ({ pricingData }) => {
  const t = useTranslations('KitPricingDisplay')
  const priceInfo = useKitPrice(pricingData as MtaKitStoryblok)

  return (
    <div>
      {priceInfo && (
        <div className={'mt-4 text-xl font-bold text-graphite-800'}>
          {formatPrice(priceInfo.amount, PaymentCurrencies[priceInfo.currency])}
        </div>
      )}
      {priceInfo?.currency === 'GBP' && (
        <p className={'text-sm text-gray-600 mt-0.5'}>{t('ukOrdersVatInfo')}</p>
      )}
    </div>
  )
}

export { KitPricingDisplay }
